<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      IT Declaration Statment

      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="title-income">Income</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Gross Salary:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right"><strong>₹ 10,00,000</strong></p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Income/Loss From Housing Property:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right"><strong>₹ 1,20,000</strong></p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Other Income:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right"><strong>₹ 1,20,000</strong></p>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="title-income">Deductions</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Exemption Under section 10:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right"><strong>₹ 1,20,000</strong></p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Exemption Under section 17:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right"><strong>₹ 1,20,000</strong></p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Deduction Under Chapter VI A:</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right"><strong>₹ 1,20,000</strong></p>
          </div>
        </div>
      </div>
      
      
      <div class="container">
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Total Taxable Income:</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">₹ 1,20,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Total Annual Tax:</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">₹ 1,20,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Tax Paid Till Date:</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">₹ 1,20,000</p>
          </div>
        </div>
      </div>

      <!-- <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back To Assign Fixed Non CTC Components "
        @back="close"
      ></pop-up-message> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Back" type="secondary" @click="goBack" />
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: "itDeclarationStatmentNewRegimePopup",
  props: {
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
    };
  },
  computed: {},

  mounted() {
    this.showSuccessMsg = false;
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    // Add here code for cancel button to hide popup By Bhushan
    goBack() {
      this.$emit("back");
    },
  },
};
</script>

<style lang="scss" scoped>

// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }


.title-income {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
}

.title-income-normal-left {
  font-size: 1.0rem;
  color: #444444;
}

.title-income-normal-right {
  font-size: 1.0rem;
  color: #444444;
  text-align: right;
}

.title-income-left {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
}

.title-income-right {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
  text-align: right;
}

</style>
